import React, { Component } from 'react';
import styled from 'styled-components';

const GenrePickerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  width: 100%;
`;

const ButtonContainer = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  flex: ${props => props.flex};
`;

const GenreButton = styled.button`
  border-radius: 4px;
  background-color: ${props => props.isSelected ? '#D9A441' : '#965A38'};
  padding: 12px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  cursor: pointer;
`;

const ButtonText = styled.span`
  font-family: 'lcdsolid';
  font-size: 14px;
  text-align: center;
  color: ${props => props.isSelected ? '#965A38' : '#D9A441'};
`;

export default class GenrePicker extends Component {
  constructor(props) {
    super(props);
  }

  renderButton(genre) {
    const isSelected = this.props.genre === genre.toUpperCase();
    
    return (
      <GenreButton 
        isSelected={isSelected}
        onClick={() => this.props.onChange(genre.toUpperCase())}
      >
        <ButtonText isSelected={isSelected}>{genre}</ButtonText>
      </GenreButton>
    );
  }

  render() {
    return (
      <GenrePickerContainer>
        <ButtonContainer flex="0.24">
          {this.renderButton('Pop')}
        </ButtonContainer>
        <ButtonContainer flex="0.28">
          {this.renderButton('Rock')}
        </ButtonContainer>
        <ButtonContainer flex="0.24">
          {this.renderButton('RnB')}
        </ButtonContainer>
        <ButtonContainer flex="0.24">
          {this.renderButton('EDM')}
        </ButtonContainer>
      </GenrePickerContainer>
    );
  }
}
